import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/resume/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/resume/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/resume/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/resume/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/resume/remove',
  method: 'post',
  params: {
    ids,
  },
})

// 设置已读
const view = params => request({
  url: '/api/mcc-staff/resume/view',
  method: 'get',
  params: {
    ...params,
  },
})
// 发送邮件
const invite = params => request({
  url: '/api/mcc-staff/resume/invite',
  method: 'post',
  data: params,
})

const exportExcel = params => request({
  url: '/api/mcc-staff/resume//excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
  invite,
  view,
  exportExcel,
};
